import { legacyPlugins } from "/opt/suncore/build/20261104T102900Z-fec39489/node_modules/nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}